module.exports = __webpack_public_path__ + "img/test.685284fd.png";